export default __webpack_public_path__ + "static/media/web-develop.a4df043b.svg";